<template>
  <div>
    <div class="overflow-auto">
      <ts-loading-banner :loading="waiting">
        <table id="table-details">
          <thead>
            <tr>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width:200px">
                {{ $t('invoice.feeType') }}
              </th>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width:200px">
                {{ $t('invoice.feeName') }}
              </th>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width: 190px;">
                {{ $t('invoice.description') }}
              </th>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width: 140px;">
                {{ $t('invoice.dateFrom') }}
              </th>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width: 140px;">
                {{ $t('invoice.dateTo') }}
              </th>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width: 70px;">
                {{ $t('invoice.qty') }}
              </th>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width: 99px;">
                {{ $t('invoice.fee') }}
              </th>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width: 93px;">
                {{ $t('invoice.discountType') }}
              </th>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width: 94px;">
                {{ $t('invoice.discount') }}
              </th>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width: 81px;">
                {{ $t('invoice.vat') }}(%)
              </th>
              <th class="ts-whitespace-no-wrap ts-uppercase" style="width: 90px;">
                {{ $t('invoice.amount') }}
              </th>
              <th style="width:1%">
                <a href="#" class="text-primary" @click.prevent="addRow">
                  <i class="fa fa-plus"></i>
                </a>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in model.inv_detail_list" :key="index">
              <td valign="top">
                <a-select v-model.number="detail.fee_type_id" style="width: 100%" :options="feeTypes"
                  @change="fetchFeeSetupDetail(detail)" />
                <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.fee_type_id')">
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_type_id')
                  }}
                </div>
              </td>
              <td valign="top">
                <a-select v-model.number="detail.fee_setup_id" style="width:100%" :showSearch="true" :options="feeSetups.filter(f => f.fee_type_id == detail.fee_type_id)
                  " :filterOption="(input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    " optionFilterProp="children" @change="onFeeSetupChange(detail)" />
                <div class="validate" v-if="
                  errors.has('inv_detail_list.' + index + '.fee_setup_id')
                ">
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_setup_id')
                  }}
                </div>
              </td>
              <td valign="top">
                <input v-model="detail.fee_description" type="text" class="form-control" />
              </td>
              <td valign="top">
                <a-date-picker valueFormat="DD-MM-YYYY" format="DD-MM-YYYY" v-model="detail.fee_start_date"
                  style="width: 100%" />
                <!-- disabled -->
                <div class="validate" v-if="
                  errors.has('inv_detail_list.' + index + '.fee_start_date')
                ">
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_start_date')
                  }}
                </div>
              </td>
              <td valign="top">
                <a-date-picker valueFormat="DD-MM-YYYY" format="DD-MM-YYYY" v-model="detail.fee_end_date"
                  style="width: 100%" />
                <!-- disabled -->
                <div class="validate" v-if="
                  errors.has('inv_detail_list.' + index + '.fee_end_date')
                ">
                  {{
                    errors.first('inv_detail_list.' + index + '.fee_end_date')
                  }}
                </div>
              </td>
              <td valign="top">
                <input type="number" min="1" class="form-control" v-model="detail.quantity" @input="calculate" />
                <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.quantity')">
                  {{ errors.first('inv_detail_list.' + index + '.quantity') }}
                </div>
              </td>
              <td valign="top">
                <input readonly type="number" step="any" class="form-control" v-model="detail.fee_amount" />
                <div class="validate" v-if="errors.has('inv_detail_list.' + index + '.fee_amount')">
                  {{ errors.first('inv_detail_list.' + index + '.fee_amount') }}
                </div>
              </td>
              <td valign="top">
                <a-select v-model="detail.discount_type" style="width: 100%" :options="[
                  { value: '$', label: '$' },
                  { value: '%', label: '%' }
                ]" @change="calculate" />
                <div class="validate" v-if="
                  errors.has('inv_detail_list.' + index + '.discount_type')
                ">
                  {{
                    errors.first('inv_detail_list.' + index + '.discount_type')
                  }}
                </div>
              </td>
              <td valign="top">
                <input v-model="detail.discount_rate" type="number" class="form-control" @input="calculate" />
              </td>
              <td valign="top">
                <input type="number" class="form-control" v-model="detail.vat_rate" />
              </td>
              <td valign="top">
                <input readonly type="number" class="form-control" v-model="detail.amount_include_vat" />
              </td>
              <td class="text-center" valign="top">
                <a href="#" class="text-red ts-mt-3" @click.prevent="removeRow(index)">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
            <tr>
              <td colspan="7" rowspan="4" valign="top" class="ts-text-right">
                <div style="width: 400px" class="ts-float-right ts-space-y-3">
                  <div class="ts-grid ts-grid-cols-3 ts-gap-3">
                    <div class="ts-flex ts-items-center ts-justify-end">
                      <strong>{{ $t('invoice.paymentMethod') }} :</strong>
                    </div>
                    <div class="ts-col-span-2">
                      <select class="form-control" v-model="model.payment_method_id" @change="onPaymentMethodChange">
                        <option v-for="(p, index) in paymentMethods" :key="index" :value="p.id">{{ p.label }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="ts-grid ts-grid-cols-3 ts-gap-3">
                    <div class="ts-flex ts-items-center ts-justify-end">
                      <strong>{{ $t('invoice.bankName') }} :</strong>
                    </div>
                    <div class="ts-col-span-2">
                      <select v-model="model.bank_id" class="form-control" :disabled="model.payment_method_id == 1">
                        <option v-for="(b, index) in bank" :value="b.bank_id" :key="index">{{ b.bank_name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="ts-grid ts-grid-cols-3 ts-gap-3">
                    <div class="ts-flex ts-items-center ts-justify-end">
                      <strong>{{ $t('invoice.account') }} :</strong>
                    </div>
                    <div class="ts-col-span-2">
                      <select v-model="model.account_id" class="form-control" :disabled="model.payment_method_id == 1">
                        <option v-for="(a, index) in accountOpt" :value="a.account_id" :key="index">{{ a.account_number
                          }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </td>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.totalAmount') }} :</strong>
              </td>
              <td colspan="2">
                <input :value="model.total_amount" type="text" class="form-control" readonly />
                <div class="validate" v-if="errors.has('total_amount')">
                  {{ errors.first('total_amount') }}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.paidAmount') }} :</strong>
              </td>
              <td colspan="2">
                <input v-model.number="model.amount_paid" type="number" step="any" class="form-control"
                  @input="customerPaid" />
                <div class="validate" v-if="errors.has('amount_paid')">
                  {{ errors.first('amount_paid') }}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.dueAmount') }} :</strong>
              </td>
              <td colspan="2">
                <input v-model.number="model.amount_due" type="number" step="any" class="form-control" readonly />
                <div class="validate" v-if="errors.has('amount_due')">
                  {{ errors.first('amount_due') }}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="text-right">
                <strong>{{ $t('invoice.nextPaymentDate') }} :</strong>
              </td>
              <td colspan="2">
                <a-date-picker :disabled="allowPickNewPaymentDate" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
                  v-model="model.next_payment_date" style="width: 100%" />
                <div class="validate" v-if="errors.has('next_payment_date')">
                  {{ errors.first('next_payment_date') }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </ts-loading-banner>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { clone, round, sumBy } from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  name: 'manualDetailCreateForNoEnroll',
  props: ['value', 'validate'],
  data() {
    return {
      waiting: false,
      model: {},
      errors: new Errors(),
      newRow: {
        fee_type_id: null,
        fee_setup_id: null,
        fee_description: null,
        quantity: 1,
        fee_start_date: null,
        fee_end_date: null,
        payment_term_id: null,
        duration_in_month: null,
        fee_amount: 0,
        discount_type: '%',
        discount_rate: 0,
        discount_amount: 0,
        discount_reason: null,
        total_amount: 0,
        vat_rate: 0,
        vat_amount: 0,
        amount_include_vat: 0,
        ac_term_id: null,
        grade_id: null,
        shift_id: null,
        disabled: false // just a variable to lock item from fee group
      },
      feeTypes: [],
      feeSetups: [],
      feeItemDetails: [],
      bank: []
    }
  },
  created() {
    this.model = this.value
    // this.addRow()
    this.fetchFeeType()
  },
  computed: {
    accountOpt() {
      var opt = this.bank.find(b => b.bank_id == this.model.bank_id)
      if (opt) {
        return opt.bank_accounts
      }
      return []
    },
    allowPickNewPaymentDate() {
      return !this.model.amount_due > 0
    },
    paymentMethods() {
      return [
        { id: 1, label: 'Cash' },
        { id: 2, label: 'Cheque' },
        { id: 3, label: 'Bank Transfer' },
        { id: 4, label: 'Credit Card' }
      ]
    }
  },
  methods: {
    ...mapActions('invoice', ['getFeeType']),
    ...mapActions('invoiceForNoEnroll', ['formViewModel']),
    addRow() {
      this.model.inv_detail_list.push(clone(this.newRow))
    },
    removeRow(index) {
      this.model.inv_detail_list.splice(index, 1)
    },
    // fetch fee type when component created
    fetchFeeType() {
      this.waiting = true
      this.getFeeType({
        fields: {
          setup_payment_fee_types: 'fee_type_id,fee_type_name'
        },
        sort: '-fee_type_name',
        page: -1
      })
        .then(response => {
          this.feeTypes = response.data.map(el => ({
            value: el.fee_type_id,
            label: el.fee_type_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    // fetch fee setup detail when fee type change
    async fetchFeeSetupDetail(row) {
      if (!this.model.ac_term_id || !this.model.grade_id) {
        this.$toasted.error('Academic term or grade no selected!')
        return
      }

      if (!this.feeItemDetails.hasOwnProperty(row.fee_type_id)) {
        this.waiting = true
        let response = await this.formViewModel({
          ac_term_id: this.model.ac_term_id,
          grade_id: this.model.grade_id,
          fee_type_id: row.fee_type_id,
          invoice_date: this.model.inv_date,
          fnName: 'feeDetail'
        })

        this.feeItemDetails = Object.assign(
          {},
          this.feeItemDetails,
          response.data['feeDetail']
        ) // store temporary fee item detail when change fee type
        this.pushNewValueFeeSetup(
          Object.values(response.data['feeDetail']).flat()
        )

        this.waiting = false
      }

      this.clearRow(row)
    },
    // push a new value to be select on fee name
    pushNewValueFeeSetup(value) {
      value
        .filter(v => v.fee_setup_id > 0)
        .forEach(el => {
          if (
            !this.feeSetups.filter(f => f.value == el.fee_setup_id).length > 0
          ) {
            this.feeSetups.push({
              fee_type_id: el.fee_type_id,
              value: el.fee_setup_id,
              label: el.fee_name
            })
          }
        })
    },
    // set value to each column in details
    onFeeSetupChange(item) {
      this.feeItemDetails[item.fee_type_id]
        .filter(f => f.fee_setup_id == item.fee_setup_id)
        .forEach(el => {
          if (!this.model.remark) {
            this.model.remark = el.discount_remark
          }
          item.fee_description = el.fee_name // description is a fee name
          item.quantity = 1
          item.fee_start_date = el.fee_start_date
            ? moment(el.fee_start_date, 'DD-MM-YYYY').format('DD-MM-YYYY')
            : null
          item.fee_end_date = el.fee_end_date
            ? moment(el.fee_end_date, 'DD-MM-YYYY').format('DD-MM-YYYY')
            : null
          item.payment_term_id = el.payment_term_id
          item.duration_in_month = el.duration_in_month
          item.fee_amount = el.fee_amount
          item.discount_rate = el.discount_rate
          item.discount_reason = el.discount_remark ? el.discount_remark : null
          item.ac_term_id = el.ac_term_id
          item.grade_id = el.grade_id
          item.shift_id = el.shift_id
          if (item.fee_type_id == 1) {
            // just show expired date to user if have promotion
            this.model.promtion_expired_date = el.promotion_expiry_date
              ? moment(el.promotion_expiry_date, 'DD-MM-YYYY')
              : null
          }
        })
      this.calculate()
    },
    // calculate invoice amount
    calculate() {
      var price = 0
      if (this.model.inv_detail_list.length > 0) {
        this.model.inv_detail_list.forEach(detail => {
          detail.quantity = detail.quantity ? detail.quantity : 1
          price = round(detail.fee_amount ? detail.fee_amount * detail.quantity : 0, 2)

          if (detail.discount_type == '%') {
            detail.discount_amount = detail.discount_rate
              ? round(price * (detail.discount_rate / 100), 2)
              : 0
          }
          if (detail.discount_type == '$') {
            detail.discount_amount = round(detail.discount_rate || 0, 2)
          }

          detail.total_amount = round(price - detail.discount_amount, 2)
          detail.vat_amount = round(
            detail.vat_rate
              ? detail.total_amount * (detail.vat_rate / 100)
              : 0,
            2
          )
          detail.amount_include_vat = round(
            detail.total_amount + detail.vat_amount,
            2
          )
        })

        let sumAmountIncludeVat = round(
          sumBy(this.model.inv_detail_list, 'amount_include_vat'),
          2
        )
        this.model.total_amount = sumAmountIncludeVat
        this.model.amount_paid = round(this.model.total_amount, 2)
        this.model.amount_due = round(
          this.model.total_amount - this.model.amount_paid,
          2
        )
      } else {
        this.model.total_amount = 0
        this.model.amount_paid = 0
        this.model.amount_due = 0
        this.model.next_payment_date = null
      }
    },
    // set each row to default by fee type change
    clearRow(row) {
      row.fee_setup_id = null
      row.fee_description = ''
      row.quantity = 1
      row.fee_start_date = null
      row.fee_end_date = null
      row.payment_term_id = null
      row.duration_in_month = null
      row.fee_amount = 0
      row.discount_rate = 0
      row.discount_amount = 0
      row.discount_reason = null
      row.total_amount = 0
      row.vat_rate = 0
      row.vat_amount = 0
      row.amount_include_vat = 0
      row.ac_term_id = null
      row.grade_id = null
      row.shift_id = null
    },
    async onPaymentMethodChange() {
      if (this.model.payment_method_id == 1) {
        this.model.bank_id = null
        this.model.account_id = null
      } else {
        this.waiting = true
        let response = await this.formViewModel({
          fnName: 'bank'
        })
        this.bank = response.data['bank']
        this.waiting = false
      }
    },
    customerPaid() {
      this.model.amount_due = round(
        this.model.total_amount - this.model.amount_paid,
        2
      )
      if (this.model.amount_due > 0) {
        this.model.next_payment_date = moment()
          .add(7, 'Day')
          .format('DD-MM-YYYY')
      } else {
        this.model.next_payment_date = null
      }
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
* {
  font-size: 12px !important;
}

#table-details>thead>tr>th {
  padding: 5px 4px;
  background: #f2f3f4;
}

#table-details>tbody>tr>td {
  padding: 5px 4px;
  border: none !important;
  font-size: 12px !important;
}

.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
